import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt, faGlobe, faHandshake, faLaptop, faUser } from '@fortawesome/free-solid-svg-icons';
import Carousel from '../../components/Carousel';
import './WhyChooseUs.css';

const WhyChooseUs = () => {
    const { t } = useTranslation();

    const features = [
        { key: 'quality', icon: faGlobe, color: 'primary' },
        { key: 'individual', icon: faUser, color: 'secondary' },
        { key: 'equipment', icon: faLaptop, color: 'accent' },
        { key: 'fast', icon: faBolt, color: 'success' },
        { key: 'support', icon: faHandshake, color: 'info' },
    ];

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.1 }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, scale: 0.9 },
        visible: { opacity: 1, scale: 1 }
    };

    const FeatureCard = ({ feature }) => (
        <div className={`feature-card feature-${feature.color}`}>
            <div className="feature-icon-wrapper">
                <span className="feature-icon" aria-hidden="true">
                    <FontAwesomeIcon icon={feature.icon} />
                </span>
            </div>
            <h3 className="feature-title">{t(`why_us.features.${feature.key}.title`)}</h3>
            <p className="feature-description">{t(`why_us.features.${feature.key}.description`)}</p>
        </div>
    );

    return (
        <section id="why-us" className="section why-us-section">
            <div className="container">
                {/* Header */}
                <motion.div
                    className="section-header"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                >
                    <h2 className="section-title">{t('why_us.title')}</h2>
                    <p className="section-subtitle">{t('why_us.subtitle')}</p>
                </motion.div>

                {/* Desktop Features Grid */}
                <motion.div
                    className="features-grid features-grid--desktop"
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                >
                    {features.map((feature) => (
                        <motion.div key={feature.key} variants={itemVariants}>
                            <FeatureCard feature={feature} />
                        </motion.div>
                    ))}
                </motion.div>

                {/* Mobile Carousel */}
                <div className="features-carousel features-carousel--mobile">
                    <Carousel showArrows={false}>
                        {features.map((feature) => (
                            <FeatureCard key={feature.key} feature={feature} />
                        ))}
                    </Carousel>
                </div>
            </div>
        </section>
    );
};

export default WhyChooseUs;
